import type { MouseEvent } from "react";

import { EmptyStateOverlayContent } from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/EmptyStateOverlayContent";
import { Scraping } from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/RankTracker/BodyByState/Scraping";
import {
    EMPTY_MESSAGE,
    SHARED_TOPIC_CREATION_TOOLTIP,
} from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/RankTracker/texts";
import type { RankTrackerEmptyState } from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/types";

import { EMPTY_STATE_CTA_KEY } from "../constants";

type EmptyOverlayContentSchema = {
    onClick: (e?: MouseEvent) => Promise<void>;
    emptyState: RankTrackerEmptyState;
    isOwn: boolean;
};

export const EmptyOverlayContent = ({ onClick, emptyState, isOwn }: EmptyOverlayContentSchema) => {
    return emptyState === "scraping" ? (
        <Scraping />
    ) : (
        <EmptyStateOverlayContent
            messageKey={EMPTY_MESSAGE}
            ctaKey={EMPTY_STATE_CTA_KEY[emptyState]}
            onClick={onClick}
            tooltipContent={!isOwn ? SHARED_TOPIC_CREATION_TOOLTIP : undefined}
            isDisabled={!isOwn}
        />
    );
};
